import React, { useState } from "react";
import { BCNewOrderRequest } from "../../../Interfaces/BCNewOrderRequest";
import { useAppSelector } from "../../../Redux/hooks";
import { Button, Card, Form, Input, Select } from "antd";
import {
    CloseOutlined
} from "@ant-design/icons";
import { Service } from "../../../Interfaces/Service";
import { BCCustomer } from "../../../Interfaces/BCCustomer";
import { BCShippingAddress } from "../../../Interfaces/BCShippingAddress";
import { DataService } from "../../../Services/DataService";
import { BCServiceContact } from "../../../Interfaces/BCServiceContact";

type Props = {
    onExit: () => void;
    onFinish: (request: BCNewOrderRequest) => void;
    request: BCNewOrderRequest | undefined;
}
const NewServiceOrderGeneral = (props: Props) => {

    const user = useAppSelector(state => state.user);
    const [form] = Form.useForm();

    const [customers, setCustomers] = useState<Service<BCCustomer[]>>({ status: "loading" });
    const [addresses, setAddresses] = useState<Service<BCShippingAddress[]>>({ status: "loading" });
    const [contacts, setContacts] = useState<Service<BCServiceContact[]>>({ status: "loading" });

    React.useEffect(() => {
        DataService.getCustomers().then(res => {
            setCustomers(res);
        }).catch(err => {
            setCustomers({ status: "error", error: err })
        });
        if (props.request) {
            getAddresses(props.request.customerNo);
        }
    }, []);

    function getAddresses(customerNo: string) {
        DataService.getShippingAddresses(customerNo).then(res => {
            setAddresses(res);
        }).catch(err => {
            setAddresses({ status: "error", error: err })
        })
    }

    function getContacts(customerNo: string) {
        DataService.getServiceContacts(customerNo).then(res => {
            setContacts(res);
        }).catch(err => {
            setContacts({ status: "error", error: err })
        })
    }

    function onNext(values: any) {
        props.onFinish({
            addressCode: values.addressCode == "0" ? "" : values.addressCode,
            customerNo: values.customerNo,
            description: values.description,
            title: values.title,
            resourceNo: user.resourceNo!,
            contact: values.contact,
            lines: []
        });
    }

    return (
        <Card
            className="service-card"
            style={{ minWidth: 400, flex: 0.5 }}
            title={(
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", color: "white" }}>
                    <span >Nieuw serviceorder</span>
                    <CloseOutlined onClick={props.onExit} />
                </div>
            )}
        >
            <div style={{ fontWeight: "bold", color: "#69ACFD", marginBottom: 16 }} >Algemene info</div>
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                onFinish={onNext}
                labelWrap
                style={{ paddingLeft: 16 }}
            >
                <Form.Item
                    name="title"
                    label="Titel"
                    rules={[{ required: true, message: 'Titel verplicht' }]}
                    initialValue={props.request ? props.request.title : undefined}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="description"
                    label="Bijkomende info intern"
                    rules={[{ required: true, message: 'Bijkomende info intern verplicht' }]}
                    initialValue={props.request ? props.request.description : undefined}
                >
                    <Input.TextArea />
                </Form.Item>
                <Form.Item
                    name="customerNo"
                    label="Klant"
                    rules={[{ required: true, message: 'Klant verplicht' }]}
                    initialValue={props.request ? props.request.customerNo : undefined}
                >
                    <Select
                        showSearch
                        onChange={(item) => {
                            form.resetFields(["addressCode"]);
                            getAddresses(item);
                            form.resetFields(["contact"]);
                            getContacts(item);
                        }}
                        filterOption={(inputValue, option) =>
                            option!.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        options={customers.status === "loaded" ? customers.payload.map(x => {
                            return {
                                label: x.name + ` (${x.no})`,
                                value: x.no
                            }
                        }) : []} placeholder="Kies klant" />

                </Form.Item>
                <Form.Item
                    name="addressCode"
                    label="Verzend adres"
                    rules={[{ required: true, message: 'Adres verplicht' }]}
                    initialValue={props.request ? (props.request.addressCode == "" ? "0" : props.request.addressCode) : undefined}
                >
                    <Select
                        showSearch
                        filterOption={(inputValue, option) =>
                            option!.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        options={addresses.status === "loaded" ? [{ label: "Standaard adres", value: "0" }].concat(addresses.payload.map(x => {
                            return {
                                label: `${x.address}, ${x.postCode} ${x.city}`,
                                value: x.code
                            }
                        })) : []} placeholder="Kies adres" />

                </Form.Item>
                <Form.Item
                    name="contact"
                    label="Contact"
                    initialValue={props.request ? props.request.contact : undefined}
                >
                    <Select
                    allowClear
                        showSearch
                        filterOption={(inputValue, option) =>
                            option!.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        options={contacts.status === "loaded" ? contacts.payload.map(x => {
                            return {
                                label: `${x.name}`,
                                value: x.no
                            }
                        }) : []} placeholder="Kies contact" />

                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>

                    <Button
                        size="large"
                        type="primary"
                        style={{ backgroundColor: "#1C253B", boxShadow: "none", width: "100%" }}
                        htmlType="submit"
                        className="astena-btn"
                    >
                        {"Volgende"}
                    </Button>

                </Form.Item>
            </Form>
        </Card>

    );
};

export default NewServiceOrderGeneral;